import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "py-1"
};
const _hoisted_2 = {
  src: "/img/qb16x16.png"
};
import { truncateFileName } from '@/utils/attachmentsToFileSelector.js';
export default {
  __name: 'FileChip',
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  emits: ['delete', 'preview'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleDelete = () => {
      emit('delete', props.file);
    };
    const showPreview = () => {
      emit('preview');
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_chip, {
        size: "large",
        variant: "outlined",
        "close-icon": "mdi-delete",
        label: ""
      }, {
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "green-darken-4 mx-2",
          onClick: handleDelete
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" mdi-window-close ", -1)]))]),
          _: 1
        })]),
        prepend: _withCtx(() => [_withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [[_vShow, __props.file.isQuickBooksAttachment]])]),
        default: _withCtx(() => [_createElementVNode("span", {
          class: "ml-2",
          onClick: showPreview
        }, _toDisplayString(_unref(truncateFileName)(__props.file.name)), 1)]),
        _: 1
      })]);
    };
  }
};